import { Directive, EmbeddedViewRef, Inject, Input, TemplateRef, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[prematchAnimateValue]',
    standalone: true,

})
export class PrematchAnimateValueDirective {
    private prevViewRef: EmbeddedViewRef<any>|null = null;
    private viewRef: EmbeddedViewRef<any>|null = null;
    private val: any;

    @Input('prematchAnimateValue')
    set _val(value: any) {
        if ((this.val !== value) || !this.viewRef) {
            this.val = value;
            this._updateView();
        }
    }

    constructor(
        private vc: ViewContainerRef,
        @Inject(TemplateRef)
        private tmp: TemplateRef<any>
    ) {}

    private bindCls(viewRef: EmbeddedViewRef<any>, addClass: string[], removeClass?: string[]): void {
        if (viewRef?.rootNodes?.length) {
            for (const node of viewRef.rootNodes) {
                if (node.classList) {
                    for (const cls of addClass) {
                        node.classList.add(cls);
                    }
                    if (removeClass) {
                        for (const cls of removeClass) {
                            node.classList.remove(cls);
                        }
                    }
                }
            }
        }
    }

    private _updateView(): void {
        const prevIdx = this.vc.indexOf(this.prevViewRef!);
        if (prevIdx !== -1) {
            this.vc.remove(prevIdx);
        }
        this.prevViewRef = this.viewRef;
        this.bindCls(this.prevViewRef!, ['anim-out'], ['anim-in']);
        this.viewRef = this.vc.createEmbeddedView(this.tmp, {'$implicit': this.val});
        this.bindCls(this.viewRef, this.prevViewRef? ['anim-init', 'anim-in'] : ['anim-init']);
    }
}
